import { useMutation } from '@tanstack/react-query';
import {
  WithdrawRequestService,
  CreateWithdrawRequestDto,
  CreateWithdrawRequestEntity,
} from 'services/openapi';

export const useCreateRequestWithdrawMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<CreateWithdrawRequestEntity, Error, CreateWithdrawRequestDto>({
      mutationFn: (variables: CreateWithdrawRequestDto) => {
        return WithdrawRequestService.withdrawRequestControllerCreate(
          variables,
        );
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
